import { getClient } from '@/api/app';
/**
 * 全局配置
 */
import featrueList from './features';

const isProduction = process.env.NODE_ENV === 'production' && process.env.CLOUD_ENV === 'production';
const isTest = process.env.CLOUD_ENV === 'test';
const isDev = process.env.CLOUD_ENV === 'develop';
const timeStamp = process.env.TIME_STAMP;

/**
 * 判断当前客户端
 */
let client = getClient();
let platform = ( client === 'IOS' || client === 'Android' ) ? 'app' : 'web';
let official = 'https://reolink.com.cn';
let accountCenter;
let envFlag;
let api;
let cloudConfig;

if ( isProduction ) {

    envFlag = '';
    accountCenter = 'https://my.reolink.com.cn';
    api = 'https://apis.reolink.com.cn';
    cloudConfig = 'live';

} else if ( isTest ) {

    accountCenter = 'https://my.sandbox.reolink.com.cn';
    envFlag = 'sandbox';
    api = 'https://apis.sandbox.reolink.com.cn';
    cloudConfig = 'snd';

} else if ( isDev ) {

    accountCenter = 'https://my.develop.reolink.com.cn';
    envFlag = 'develop';
    api = 'https://apis.develop.reolink.com.cn';
    cloudConfig = 'dev';

} else {

    accountCenter = 'https://my.develop.reolink.com.cn';
    envFlag = 'develop';
    api = 'https://apis.develop.reolink.com.cn';
    cloudConfig = 'dev';

}

let envFlagString = envFlag === '' ? '' : envFlag + '.';

export const config = {
    // 是否开启debuger模式
    isDebug: false,
    envFlag: envFlag,
    envFlagString: envFlagString,
    // 语言
    lang: 'zh',
    langList: [
        'zh'
    ],
    isProduction,
    // 版本号 v1.0 || v9.9
    version: 'v1.0',
    // url请求头
    urlHead: `${api}/${this.version}`,
    reolink: official,
    baseUrl: `${api}/`,
    cloudVideoPageUnit: 40,
    accountCenterLoginUrl: `${accountCenter}/login`,
    accountCenterSignupUrl: `${accountCenter}/login#signup`,
    accountCenterProfileUrl: `${accountCenter}/`,
    accountCenterSecurityUrl: `${accountCenter}/#account`,
    accountCenterLogoutUrl: `${accountCenter}/logout`,
    signipRedirect: `${accountCenter}/login#signup?redirect=${window.location.origin}/user/cloud-library/`,
    s3ProUrl: '',
    clientId: `VvLjRXCUUKI3jkwlbug41HoA`,
    defaultAvatar: 'https://cdn.reolink.com/wp-content/uploads/2018/06/default-avatar.png',
    subscribeUrl: '/',
    facebookUrl: '',
    twitterUrl: '',
    contact_us: `${official}/contact-us/`,
    conditions: `${official}/terms-of-use/`,
    privacy: `${official}/privacy-policy/`,
    app_store: 'https://reolink.com.cn/software-download/',
    google_play: 'https://reolink.com.cn/software-download/',
    about_us: `${official}/about-us/`,
    support_email: 'support@reolink.com.cn',
    featrue: featrueList,
    ga_enabled: false,
    support_url: `${official}/contact-us/`,
    firmware_url: '/',
    cloud_support: '/',
    logo: '',
    support_team: `${official}/contact-us/`,
    support_cloud_url: 'https://reolink.com.cn/support-center/',
    platform,
    client,
    basic_plan_title: 'Basic Plan',
    beta_plan_title: 'Beta Plan',
    s3Config: `https://reolink-storage.oss-cn-shenzhen.aliyuncs.com/website/cloud/public/${cloudConfig}/cloud-config.json?sv=${timeStamp}`,
    officialStore: official
};

export const setConfig = ( key, value ) => {

    config[ key ] = value;

};



// WEBPACK FOOTER //
// ./src/config/oem/reolink-cn/index.js